import script from "./SpinnerBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinnerBar.vue?vue&type=script&setup=true&lang=ts"

import "./SpinnerBar.vue?vue&type=style&index=0&id=0effa317&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0effa317"]])

export default __exports__